export { VouchersType } from '@wix/ambassador-premium-vouchers/types';

export enum PlanType {
  Website = 'website',
  Business = 'business',
  Enterprise = 'enterprise',
}

// please don't change type - https://jira.wixpress.com/browse/PREM-13075
export enum PaymentCycle {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  YEARLY = 'YEARLY',
  YEAR2 = 'YEAR2',
  YEAR3 = 'YEAR3',
  YEAR4 = 'YEAR4',
  YEAR5 = 'YEAR5',
}

export enum Vertical {
  Default = 'Default',
  Bookings = 'Bookings',
  Stores = 'Stores',
  Restaurants = 'Restaurant-1',
  Hotels = 'Hotels',
  Music = 'Music',
  Video = 'Video',
  Events = 'Events',
  ArtStore = 'Art Store',
  PaidPlans = 'Paid Plans',
  Fitness = 'Fitness',
  OnlinePrograms = 'OnlinePrograms',
  NonProfit = 'NonProfit',
}

export enum SaleMode {
  SeasonalSale = 'SeasonalSale',
  PersonalSale = 'PersonalSale',
  SeasonalExtended = 'SeasonalExtended',
  SpecialDiscount = 'SpecialDiscount',
  None = 'None',
}

export enum PurchaseModeV2 {
  InitialPurchase = 'initialPurchase',
  SecondUpgrade = 'secondUpgrade',
  ChangePlan = 'changePlan',
  Anonymous = 'anonymous',
}
export enum PurchaseMode {
  SALE = 'sale',
  PERSONAL_SALE_AGE_1 = 'personalSale1',
  PERSONAL_SALE_AGE_2 = 'personalSale2',
  PERSONAL_SALE_AGE_3 = 'personalSale3',
  SEASONAL_EXTENDED = 'seasonalExtended',
  LAST_DAY_SALE = 'lastSaleDay',
  CHANGE_PLAN = 'changePlan',
  SPECIAL_DISCOUNT = 'specialDiscount',
  DEFAULT = 'default',
}

export enum Language {
  CS = 'cs',
  DA = 'da',
  DE = 'de',
  EN = 'en',
  ES = 'es',
  FI = 'fi',
  FR = 'fr',
  HI = 'hi',
  IT = 'it',
  JA = 'ja',
  KO = 'ko',
  NL = 'nl',
  NO = 'no',
  PL = 'pl',
  PT = 'pt',
  RU = 'ru',
  SV = 'sv',
  TH = 'th',
  TR = 'tr',
  UK = 'uk',
  ZH = 'zh',
  VI = 'vi',
  ID = 'id',
  IN = 'in',
  INVALID = 'invalid',
}

export enum Country {
  CA = 'CA',
  USA = 'US',
  GB = 'GB',
  AU = 'AU',
  FR = 'FR',
  BR = 'BR',
  RU = 'RU',
  DE = 'DE',
  JA = 'JP',
  IN = 'IN',
  BE = 'BE',
  CH = 'CH',
  ES = 'ES',
  IE = 'IE',
  IL = 'IL',
  IT = 'IT',
  KZ = 'KZ',
  NL = 'NL',
  NO = 'NO',
  NZ = 'NZ',
  PL = 'PL',
  PT = 'PT',
  SE = 'SE',
  TR = 'TR',
  ZA = 'ZA',
  AT = 'AT',
  BY = 'BY',
  BG = 'BG',
  HR = 'HR',
  CY = 'CY',
  CZ = 'CZ',
  DK = 'DK',
  FI = 'FI',
  GR = 'GR',
  HU = 'HU',
  IS = 'IS',
  LV = 'LV',
  LT = 'LT',
  RO = 'RO',
  SA = 'SA',
  SK = 'SK',
  SI = 'SI',
  UA = 'UA',
  AE = 'AE',
  AQ = 'AQ',
  AS = 'AS',
  EH = 'EH',
  FM = 'FM',
  GU = 'GU',
  IM = 'IM',
  MH = 'MH',
  MP = 'MP',
  PR = 'PR',
  PW = 'PW',
  VI = 'VI',
  AX = 'AX',
  BV = 'BV',
  HM = 'HM',
  UM = 'UM',
  PH = 'PH',
  EE = 'EE',
  LU = 'LU',
  MT = 'MT',
}

export const AVALARA_EXCLUDED_GEOS = [
  Country.IN,
  Country.BR,
  Country.AQ,
  Country.AS,
  Country.EH,
  Country.FM,
  Country.GU,
  Country.IM,
  Country.MH,
  Country.MP,
  Country.PR,
  Country.PW,
  Country.VI,
  Country.AX,
  Country.BV,
  Country.HM,
  Country.UM,
];

export const CREDIT_CARD_RATES_EU_GEOS = [
  Country.AT,
  Country.BE,
  Country.FI,
  Country.DE,
  Country.IE,
  Country.IT,
  Country.LT,
  Country.NL,
  Country.PT,
  Country.ES,
];

export const AD_VOUCHER_75_GEOS = [
  Country.AU,
  Country.BE,
  Country.CH,
  Country.DE,
  Country.ES,
  Country.FR,
  Country.IE,
  Country.IL,
  Country.IT,
  Country.KZ,
  Country.NL,
  Country.NO,
  Country.NZ,
  Country.PL,
  Country.PT,
  Country.SE,
  Country.TR,
  Country.ZA,
  Country.AT,
  Country.BY,
  Country.BG,
  Country.HR,
  Country.CY,
  Country.CZ,
  Country.DK,
  Country.FI,
  Country.GR,
  Country.HU,
  Country.IS,
  Country.LV,
  Country.LT,
  Country.RO,
  Country.SA,
  Country.SK,
  Country.SI,
  Country.UA,
  Country.AE,
];

export const SEPA_ENABLED_COUNTRIES = [
  Country.AT,
  Country.BE,
  Country.CY,
  Country.EE,
  Country.FI,
  Country.FR,
  Country.DE,
  Country.GR,
  Country.IE,
  Country.IT,
  Country.LV,
  Country.LT,
  Country.LU,
  Country.MT,
  Country.NL,
  Country.PT,
  Country.SK,
  Country.SI,
  Country.SE,
  Country.ES,
];

export enum ProductFamily {
  Default = 'Default',
  Pro = 'Pro',
  VIP = 'Vip',
  Unlimited = 'Unlimited',
  Enterprise = 'Enterprise',
  // eslint-disable-next-line @typescript-eslint/no-shadow
  Vertical = 'Vertical',
  Evolve = 'Evolve',
  Grow = 'Grow',
  Sell = 'Sell',
  Combo = 'Combo',
  ConnectDomain = 'Connect_Domain',
  Essential = 'Essential',
  Extra = 'Extra',
  Ultra = 'Ultra',
  Launch = 'Launch',
  Boost = 'Boost',
  Scale = 'Scale',
  Lite = 'Lite',
  Basic = 'Basic',
  Standard = 'Standard',
  Advanced = 'Advanced',
  Dayful = 'Dayful',
  Light = 'Light',
  Core = 'Core',
  Business = 'Business',
  Elite = 'Elite',
  Plus = 'Plus',
}

export enum SectionCategory {
  COMPLETE_ECOMMERCE_PLATFORM = 'COMPLETE_ECOMMERCE_PLATFORM',
  ONLINE_BOOKINGS_CALENDAR = 'ONLINE_BOOKINGS_CALENDAR',
  TICKETS_EVENT_MANAGEMENT = 'TICKETS_EVENT_MANAGEMENT',
  MONETIZE_YOUR_ART_CONTENT = 'MONETIZE_YOUR_ART_CONTENT',
  TAKE_ONLINE_ORDERS = 'TAKE_ONLINE_ORDERS',
  MANAGE_HOTEL_RESERVATIONS = 'MANAGE_HOTEL_RESERVATIONS',
  MARKETING_SUITE = 'MARKETING_SUITE',
  DEFAULT = 'DEFAULT', // relevant only to dealer integration
  COMPLETE_SOLUTION_FOR_FITNESS_PROS = 'COMPLETE_SOLUTION_FOR_FITNESS_PROS',
  DEVELOPER = 'DEVELOPER',
  ONLINE_PROGRAMS = 'ONLINE_PROGRAMS',
}

export enum ProductChangeType {
  Upgrade = 'Upgrade',
  Downgrade = 'Downgrade',
  None = 'None',
}

export enum SwitchPlanType {
  Refund = 'Refund',
  GracePeriod = 'GracePeriod',
  Extend = 'Extend',
}

export enum CurrentPlanInOfferingMode {
  None = '',
  ProductFullMatch = 'product_full_match',
  ProductPartialMatch = 'product_partial_match',
  ProductNotMatch = 'product_not_match',
}

export enum RefundCapabilityType {
  REFUNDABLE_NEGATIVE_BALANCE = 'REFUNDABLE_NEGATIVE_BALANCE',
  REFUNDABLE = 'REFUNDABLE',
  NOT_ENOUGH_BALANCE = 'NOT_ENOUGH_BALANCE',
  PARTIAL_REFUND_NOT_ALLOWED = 'PARTIAL_REFUND_NOT_ALLOWED',
  TRANSACTION_TOO_OLD = 'TRANSACTION_TOO_OLD',
  TRANSACTION_NOT_FOUND = 'TRANSACTION_NOT_FOUND',
}

export enum Experiments {
  NewMobileSearchDomainPage = 'specs.premium.NewMobileSearchDomainPage_DOM2_2301',
  CycleSelectorsInProductsPage = 'specs.premium.CycleSelectorsInProductsPage',
  AddEnterpriseProduct = 'specs.premium.AddEnterpriseProduct',
  AddEditorXEnterpriseProduct = 'specs.premium.AddEditorXEnterpriseProduct',
  RelativeSepaSuccessRedirect = 'specs.premium.RelativeSepaSuccessRedirect',
  EnforcePurchaseModeForSled = 'specs.premium.EnforcePurchaseModeForSled',
  // PREM_1507_30_40_50 = 'specs.premium.30_40_50_Prem15076',
  AscendBundle = 'specs.premium.AscendBundle_15504',
  AddEnterpriseTab = 'specs.premium.AddEnterpriseTab_15954',
  ErrorMessagesImprovement = 'specs.premium.ErrorMessagesImprovement',
  useDealerIntegrationIntentBasedElements = 'specs.premium.useDealerIntegrationIntentBasedElements',
  addCorreiosToOffering = 'specs.premium.addCorreiosToOffering_17160',
  adVouchersPricesFromServer = 'specs.premium.UseNewGoogleAdwordsTerms',
  NoVatInCheckoutSummery = 'specs.premium.noVatInCheckoutSummary',
  EnableSepaNoRefundDisclaimers = 'specs.premium.EnableSepaNoRefundDisclaimers',
  EnableDynamicOfferingPlans = 'specs.premium.EnableDynamicOfferingForPlans',
  UseMarketingDealerForPlans_387 = 'specs.premium.UseMarketingDealerForPlans_387',
  DisplayDomainNameInDomainFeature = 'specs.premium.DisplayDomainNameInDomainFeature',
  FeaturesGroupingPlansGrid = 'specs.premium.FeaturesGroupingPlansGrid',
  TrustedShops = 'specs.premium.TrustedShops_PREM2_2237',
  EnablePaymentTypeFiltersSpec = 'specs.premium.EnablePaymentTypeFiltersSpec',
  SecondUpgradeNewSuccessPage = 'specs.premium.SecondUpgradeNewSuccessPage',
  StoreIntentNoTabs = 'specs.premium.storeIntentNoTabs_PREM2_4070',
  FranchPackagePicker = 'specs.premium.FranchPackagePicker', // TODO when merge this spec, do it also in premium-marketing-data
  JapanesePackagePicker = 'specs.premium.JapanesePackagePicker', // TODO when merge this spec, do it also in premium-marketing-data
  // enable remove voucher row
  Active2ndUpgradeFreeDomainVoucher = 'specs.premium.Active2ndUpgradeFreeDomainVoucher',
  // enable both remove voucher row + remove voucher V for downgrade plans
  Active2ndUpgradeFreeDomainVoucherPhase2 = 'specs.premium.Active2ndUpgradeFreeDomainVoucherPhase2',
  AddCheckoutForDowngradeDeclinedChangePlan = 'specs.premium.AddCheckoutForDowngradeDeclinedChangePlan',
  NewMobilePackagePicker = 'specs.premium.NewMobilePackagePicker',
  CheckoutSavings = 'specs.premium.Checkout_Savings_PREM2-5543',
  BookingsAnywhere = 'specs.premium.BookingsAnywhere',
  useFitnessContent_PREM_17393 = 'specs.premium.useFitnessContent_PREM-17393',
  Active2ndUpgradeFreeDomainVoucherDynamicOffering = 'specs.premium.Active2ndUpgradeFreeDomainVoucherDynamicOffering',
  ReassignSuccessPage = 'specs.premium.EnableReassignSuccessPage',
  useTabDSModel = 'specs.premium.useTabDSModel',
  useAbTranslate = 'specs.premium.useAbTranslate',
  MobileSalePlansFirst = 'specs.premium.MobileSalePlansFirst_PREM2-8210',
  DealerPlansOrder = 'specs.premium.PP_Reorder_Plans_L2R',
  NewFeatureBadge = 'specs.premium.NewFeatureBadge',
  FormsFeaturesInPackagePicker = 'specs.premium.FormsFeaturesInPackagePicker',
  SunriseV2 = 'specs.premium.SunriseV2',
  EnableSunriseV2 = 'specs.premium.EnableSunriseV2',
  SunriseV2_EnableSaleBubble = 'specs.premium.SunriseV2.EnableSaleBubble',
  MonthlyCycleInIndia = 'specs.premium.MonthlyCycleInIndia_PREM2-8581',
  DynamicHat = 'specs.premium.DynamicHat',
  NewMobileProductCards = 'spec.premium.NewMobileProductCards',
  SunriseAnonymous = 'specs.premium.SunriseAnonymous',
  ResellerRedirect = 'specs.premium.ResellerRedirect',
  FaqCommonComponent = 'specs.premium.FaqCommonComponent',
  EnableSandbox = 'specs.premium.EnableSandbox',
  NewStudioAnonymousContent = 'specs.premium.NewStudioAnonymousContent',
  EditorXToStudioMigration = 'specs.premium.EditorXToStudioMigration',
  ChangePlanNewContent = 'specs.premium.ChangePlanNewContent',
  ChangePlanProductFamilyFix = 'specs.premium.ChangePlanProductFamilyFix',
  SunriseAnonymousMoneyBackGuarantee = 'specs.premium.SunriseAnonymousMoneyBackGuarantee',
  NewNoSitesModal = 'specs.premium.NewNoSitesModal',
  MobileCreditSubtitle = 'specs.premium.MobileCreditSubtitle',
  ChangePlanExtendContentFix = 'specs.premium.ChangePlanExtendContentFix',
  UsePMDCache = 'specs.premium.UsePMDCache',
  FunnelMetasiteApi = 'specs.premium.FunnelMetasiteApi',
  MoneyBackGuaranteeInSepa = 'specs.premium.EnableMoneyBackGuaranteeInSepa',
  AnonymousPremiumPacakgePickerWixOnWix = 'specs.premium.AnonymousPremiumPacakgePickerWixOnWix',
  PermissionDeniedError = 'specs.premium.PremiumPurchasePlanPermissionDeniedError',
  NewLowTierPlan = 'premium.specs.NewLowTierPlan',
  DefaultTwoYearsCycle = 'specs.premium.2years_Cycle_Default_PRM-952',
  DefaultTreeYearsCycle = 'specs.premium.defaultTreeYearsCycle',
  EnableNewPlanSuccesPageDesktop = 'premium.spec.enableNewPlanSuccesPageDesktop',
  EnableUseOfAssetsV2 = 'specs.premium-plans-fed.PurchasePlanAssetsV2',
  StorefrontToCart = 'specs.premium.StorefrontToCart',
  SplitPageWithCart = 'specs.premium.SplitPageWithCart_DOM2_4049',
  UnifiedChangePlanPhase1 = 'specs.premium.UnifiedChangePlanPhase1',
  EnableTaxAwareChangePlan = 'specs.premium-plans-fed.EnableTaxAwareChangePlan',
  NewEndOfPeriodForRenewalDate = 'specs.premium-plans-fed.NewEndOfPeriodForRenewalDate',
  ReplaceChangePlanPurchaseMode = 'specs.premium.ReplaceChangePlanPurchaseMode',
  PmdViaHadron = 'specs.premium.PmdViaHadron',
  RevShare = 'specs.premium.RevShare',
  PremiumRequiredForDomainMessage = 'specs.premium.domains.RedirectToLeanPackagePicker_DOM2_4472',
  DomainUpSell = 'specs.premium.domainUpSell',
  EnableImmediateCouponsDeliverySpec = 'specs.EnableImmediateCouponsDeliverySpec',
  Expand3YearAvailability = 'specs.premium.isExpandThreeYearsEnabledV2',
  StudioSale = 'specs.premium.Studio_Sale_PREM2-19136',
  changePlanStudioSale = 'specs.premium.changePlanStudioSale',
  PersonalSaleCountdown = 'specs.premium.PersonalSaleCountdown',
  StudioUrlRedirect = 'specs.premium.StudioUrlRedirect',
  RemoveLightPlanForDropShipping = 'specs.premium.RemoveLightPlanForDropShipping',
  RemoveLightOnSale = 'specs.premium.lightExcludeFromSales',
  ClassicToStudio = 'specs.responsive-editor.classicToStudio',
  StudioSkeleton = 'specs.premium.StudioSkeleton',
  AlibabaSale = 'specs.premium.AlibabaSale',
  NewStudioPPRedirect = 'specs.premium.newStudioPPRedirect',
  PersonalSaleOneYearDefault = 'specs.premium.personalSaleOneYearDefault',
  EnableAIToolsInProductCards = 'specs.premium.AItoolsInPackagePicker',
  PermanentSaleSpec = 'specs.premium.permenant50off',
  StorefrontShowDomainMobileTitle = 'specs.premium.StorefrontShowDomainMobileTitle',
  EnableWixelLightCoupon = 'specs.premium.wixelVoucherInPP',
  MobileUiChanges = 'specs.premium.MobileUIChanges',
  MobileDisplayFirstFeatures = 'specs.premium.MobileDisplayFirstFeatures',
  DomainFirstItemPurchaseIntent = 'specs.premium.domainFirstItemPurchaseIntent',
  ConnectDoaminPPTitle = 'specs.premium.connectDoaminPPTitle',
  MobileTrust = 'specs.premium.MobileTrust',
}

export enum ProductCode {
  WEBSITE_COMBO = 'website_combo',
  WEBSITE_CONNECT_DOMAIN = 'website_connect_domain',
  WEBSITE_UNLIMITED = 'website_unlimited',
  WEBSITE_PRO = 'website_pro',
  WEBSITE_VIP = 'website_vip',
  WEBSITE_LITE = 'website_lite',
  BUSINESS_BASIC = 'business_basic',
  BUSINESS_UNLIMITED = 'business_unlimited',
  BUSINESS_VIP = 'business_vip',
  BUSINESS_ENTERPRISE = 'business_enterprise',
  BUSINESS_GROW = 'business_grow',
  BUSINESS_SELL = 'business_sell',
  BUSINESS_EVOLVE = 'business_evolve',
  OLD_PRODUCT = 'old_product',
  WEBSITE_ESSENTIAL = 'website_essential',
  WEBSITE_EXTRA = 'website_extra',
  WEBSITE_ULTRA = 'website_ultra',
  BUSINESS_LAUNCH = 'business_launch',
  BUSINESS_BOOST = 'business_boost',
  BUSINESS_SCALE = 'business_scale',
  DAYFUL_FREE = 'dayful_free',
  DAYFUL_BASIC = 'dayful_basic',
  DAYFUL_STANDARD = 'dayful_standard',
  DAYFUL_ADVANCED = 'dayful_advanced',
  LIGHT = 'light',
  CORE = 'core',
  BUSINESS = 'business',
  BUSINESS_ELITE = 'business_elite',
  ENTERPRISE = 'enterprise',
  STUDIO_BASIC = 'studio_basic',
  STUDIO_STANDARD = 'studio_standard',
  STUDIO_PLUS = 'studio_plus',
  STUDIO_ELITE = 'studio_elite',
}

export enum PageTitleKeys {
  PLANS = 'plans_page.title',
  PLANS_SECOND_UPGRADE = 'plans_page.second_upgrade_title',
  SUBSCRIPTIONS = 'subscription_page.title',
  CHECKOUT = 'checkout.title',
  BOOKINGS = 'plans_page.booking_title',
  PAYMENTS = 'plans_page.payments_title',
  BUSINESS = 'plans_page.business_title',
  ENTERPRISE = 'enterprise_plans.page.title',
  DOMAIN_INTENT = 'plans_page.domain_intent_title',
  DOMAIN_WITH_PREMIUM = 'premium-purchase-plan.header.domain.title',
  SPECIAL_DISCOUNT = 'Advanced_Plans_special_discount_title',
  FITNESS = 'plans_page_fitness_title',
  BLOG = 'plans_page.blogs_title',
  SUNRISE_DEFAULT = 'premium-purchase-plan.header.default.title',
  SUNRISE_SECOND_UPGRADE = 'premium-purchase-plan.header.second_upgrade.title',
  SUNRISE_BOOKINGS = 'premium-purchase-plan.header.bookings.title',
  SUNRISE_STORES = 'premium-purchase-plan.header.stores.title',
  SUNRISE_LEADS = 'premium-purchase-plan.header.leads.title',
  SUNRISE_FITNESS = 'premium-purchase-plan.header.fitness.title',
  STUDIO = 'studio_package_picker.header.default.title',
  NGO = 'premium-purchase-plan.header.organization.title',
}

// TODO: Add Studio, align with branding.Brands
export enum Brands {
  WIX = 'wix',
  EDITOR_X = 'editorx',
  DAYFUL = 'dayful',
}

export enum ProductMarketingGroup {
  ADVANCED = 'advanced',
  REALDEAL = 'realdeal',
  EDITOR_X = 'editorx',
  STUDIO = 'studio',
  NONE = 'none',
  OLD = 'old',
}

export enum Theme {
  Default = 'THEME_DEFAULT',
  AdvancedPlans = 'THEME_ADVANCED_PLANS',
  EditorX = 'THEME_EDITOR_X',
  Dayful = 'THEME_DAYFUL',
  WixStudio = 'THEME_WIX_STUDIO',
}

export enum PackagePickerType {
  Default = 'default',
  EditorX = 'editorx',
  Dayful = 'dayful',
  Studio = 'studio',
  Sunrise = 'sunrise',
  Sandbox = 'sandbox',
  EditorXToStudio = 'editorx_to_studio',
  GoogleVoice = 'google_voice',
  SocialMediaMarketing = 'social_media_marketing',
  Gemini = 'gemini',
  BusinessEmail = 'business_email',
  EmailMarketing = 'email_marketing',
  AiChat = 'ai_chat',
}

export enum Template {
  CandyBar = 'TEMPLATE_CANDY_BAR',
  Grid = 'TEMPLATE_GRID',
}

export enum RequestCallSource {
  AdvancedPlansBusinessPlan = 'Wix PP Business plan',
  AdvancedPlansEnterprisePlan = 'Wix PP Enterprise plan',
  AdvancedPlansWebsiteBanner = 'Wix PP Website banner',
  EditorXBusinessPlan = 'Editor X PP Business plan',
  EditorXWebsiteBanner = 'Editor X PP Website banner',
  EditorXEnterpriseBanner = 'Editor X PP Enterprise banner',
  Default = 'Wix',
  WixStudio = 'Wix Studio PP',
}

export enum RealEstateId {
  WixStudioAllPlansInclude = '0ab476c4-988a-4302-b277-53bf2418183b',
  WixStudioShowCaseItems = '1cf73c94-8432-4200-a670-9481ae0d553a',
  WixStudioMarketingCards = 'dce134e3-8e65-4a52-bd72-eb8b2e991890',
  SunriseMarketingCards = 'b126e9d0-0b33-4c59-baa3-6a5a0a1e1ddc',
  SunriseGroupedMarketingCards = 'af623de5-95f1-4568-827d-faa45ec483dc',
  AcceptPaymentMethods = '4c0d792b-9946-4571-a819-2528f1fca5fc',
  AppIntentElementsInitialPurchase = '5f4fda7d-40d5-449e-b672-bed3da55ffc6',
  AppIntentElementsSecondUpgrade = '835f042a-1e0f-4c52-b076-8359f6bc5ec1',
  RecommendedHat = '3474a021-8ae8-4e4f-bf08-88eb187e7a47',
}

export enum UserColors {
  EDU = 'EDU',
  NONE = 'NONE',
}

export enum ProductOfferingDTO {
  Old = 'old',
  New = 'new',
}

export enum Bundle {
  Responsive = 'responsive',
  Mobile = 'mobile',
}

export enum ChangePlanErrorType {
  NONE = 'none',
  DATA_RETRIEVAL_FAILED = 'data_retrieval_failed',
  CHANGE_FAILED = 'change_failed',
  INVALID_EU_VAT = 'invalid_eu_vat_number_exception',
}

export enum MediaDevices {
  Desktop = 'desktop',
  Tablet = 'tablet',
  Mobile = 'mobile',
}

export enum Step {
  Plans = 0,
  Subscriptions = 1,
  Checkout = 2,
}

export enum VoucherEligibleTlds {
  COM = 'com',
  COUK = 'co.uk',
  NET = 'net',
  ORG = 'org',
  ART = 'art',
  BE = 'be',
  BIZ = 'biz',
  CLUB = 'club',
  COACH = 'coach',
  FIT = 'fit',
  FITNESS = 'fitness',
  INFO = 'info',
  LIVE = 'live',
  NL = 'nl',
  ONLINE = 'online',
  PIRCTURES = 'pictures',
  ROCKS = 'rocks',
  SPACE = 'space',
  SHOP = 'shop',
  STORE = 'store',
  STUDIO = 'studio',
  TRAINING = 'training',
  XYZ = 'xyz',
  YOGA = 'yoga',
  FR = 'fr',
  COM_BR = 'com.br',
  DE = 'de',
}

export enum PulseCircleAnimationMode {
  DEFAULT = 'default',
  SALE = 'sale',
  CREDIT = 'credit',
  DAYFUL = 'dayful',
}

export enum DataHooks {
  ScrollRef = 'scroll-ref',
}

export enum AppFlow {
  CART = 'cart',
  CLASSIC = 'classic',
}

export enum DiscountType {
  Referral = 'referral',
}
